export const INCIDENT_TYPE_MANUAL_VIDEO_REQUEST = "manual_video_request";
export const VIDEO_IS_NO_LONGER_AVAILABLE = "Video is no longer available";
export const RETENTION_PERIOD_HAS_PASSED = "Retention period has passed";
export const START_TIME_IS_OUT_OF_30_DAY_RANGE = "Start time is out of the 30-day range";
export const EXPORTING_IMAGE_TYPE = "image/png";
